import { css, keyframes } from 'styled-components';

const DURATION = '0.3s';
const TIMING_FUNCTION = 'ease-in-out';
const DELAY = '0s';
const ITERATION_COUNT = 1;
const DIRECTION = 'normal';

const Shake = keyframes`
  0%, 100% {
    left: 0px;
  }
  20%, 60% {
    left: 15px;
  }
  40%, 80% {
    left: -15px;
  }
`;

const rightShake = keyframes`
  0%, 100% {
    left: 0px;
  }
  20%, 80% {
    left: 2px;
  }
  40%, 60% {
    left: 4px;
  }
`;

const leftShake = keyframes`
  0%, 100% {
    left: 0px;
  }
  20%, 80% {
    left: -2px;
  }
  40%, 60% {
    left: -4px;
  }
`;

const getKeyFrames = (animation) => {
  if (animation === 'shake') {
    return Shake;
  }
  if (animation === 'left-shake') {
    return leftShake;
  }
  if (animation === 'right-shake') {
    return rightShake;
  }
  return 'none';
};

export const animation = (props) => css`
  animation: ${getKeyFrames(props.animation)} ${props.animationDuration || DURATION}
    ${props.animationTimingFunction || TIMING_FUNCTION} ${props.animationDelay || DELAY}
    ${props.animationIterationCount || ITERATION_COUNT} ${props.animationDirection || DIRECTION};
`;

export const hoverAnimation = (props) => css`
  animation: ${getKeyFrames(props.hoverAnimation)} ${props.hoverAnimationDuration || DURATION}
    ${props.hoverAnimationTimingFunction || TIMING_FUNCTION} ${props.hoverAnimationDelay || DELAY}
    ${props.hoverAnimationIterationCount || ITERATION_COUNT} ${props.hoverAnimationDirection || DIRECTION};
`;
